import React, {useEffect, useState} from "react";
import Select, {MultiValue} from "react-select";
import {SelectOptionType} from "../../Model/Select/SelectOption";

interface Props {
    onChange: (newValue: MultiValue<SelectOptionType>|null) => void,
    options: any
}

export const ReportFields: React.FC<Props> = (props) => {

    const [values, setValues] = useState<any>([])
    const [options, setOptions] = useState<any>(props.options ?? [])

    const onChange = (options: any) => {
        setValues(options)
        props.onChange(options)
    }

      useEffect(() => {
          setOptions(props.options)
      }, [props.options])

    return (
        <>
            <Select
                isLoading={false}
                isMulti
                options={options}
                placeholder={""}
                noOptionsMessage={() => "No hay resultados"}
                isClearable={true}
                loadingMessage={() => "Cargando ..."}
                onChange={onChange}
                value={values}
            />
        </>
    )

}